import { GET_DETAILPRODUCT } from "../const";

export const getDetailProduct = (data: any) => {
    return {
        type: GET_DETAILPRODUCT,
        payload: data,
    };
};
